import Vue from 'vue'

const state = {
  crediteuren: []
}

const getters = {
  crediteuren: (state) => state.crediteuren
}

const actions = {
  async getCrediteuren ({commit, getters}, force) {
    if (getters.crediteuren.length > 0 && !force) {
      return
    }

    const {body} = await Vue.http.get('/crediteuren')
    commit('setCrediteuren', body.data)
  },
  async syncCrediteuren ({dispatch}) {
    await Vue.http.post('/sync/crediteuren')
    await dispatch('getCrediteuren', true)
  }
}

const mutations = {
  setCrediteuren (state, crediteuren) {
    state.crediteuren = crediteuren
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/crediteuren.js